import styled from "@emotion/styled";

export const StyledDocuments = styled.div`
  .date-group {
    margin-bottom: 10px;
  }

  .date-header {
    font-size: 22px;
    font-weight: 500;
    color: var(--primary);
    padding: 10px;
  }

  .files-list {
    display: flex;
    flex-direction: column;
    gap: 0;
  }

  .file-item {
    display: flex;
    align-items: center;
    gap: 1.5rem;
    padding: 10px;
    border-bottom: 1px solid #e5e7eb;
    transition: background-color 0.2s ease;
    &:last-child {
      border-bottom: none;
    }
  }

  .file-icon-container {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 56px;
    height: 60px;
    position: relative;
    overflow: hidden;

    .loading {
      width: 56px;
      height: 60px;
    }

    .image-file {
      height: 56px;
      width: 60px;
      object-fit: cover;
      border-radius: 5px;
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    }

    .file-icon {
      position: absolute;
      font-size: 60px;
    }

    .type-badge {
      font-size: 9px;
      font-weight: 500;
      color: white;
      background: red;
      padding: 3px 6px;
      border-radius: 3px;
      letter-spacing: 0.5px;
      z-index: 1;
      margin-top: 24px;
      max-width: 44px;
      overflow: hidden;
    }
  }

  .file-content {
    flex: 1;
    min-width: 0;

    .file-name {
      font-size: 16px;
      font-weight: 400;
      color: #1f1f1f;
      margin: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      letter-spacing: -0.3px;
    }

    .file-caption {
      font-size: 14px;
      color: #1f1f1f;
      margin: 0.35rem 0 0 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .file-meta {
      font-size: 14px;
      color: #6b7280;
      margin: 0.4rem 0 0 0;
      display: flex;
      gap: 1rem;
    }
  }

  .download-button {
    width: 40px !important;
    height: 40px !important;
    min-width: 40px !important;
    background: transparent;
    border: 1px solid var(--primary);
    font-size: 20px;
    color: var(--primary);
  }
`;
